import App from './src';
// import { getItem, setItem } from './src/storage'

export default App;